import { ref } from 'vue';

interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error';
  duration?: number;
}

const toasts = ref<Toast[]>([]);
let toastId: number = 0;

export function useToast() {
  const showToast = (message: string, type: 'success' | 'error', duration: number = 3000) => {
    const id = toastId++;

    toasts.value.push({
      id,
      message,
      type,
      duration,
    });

    setTimeout(() => {
      removeToast(id);
    }, duration);
  };

  const removeToast = (id: number) => {
    const index = toasts.value.findIndex((toast) => toast.id === id);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  };

  return {
    toasts,
    showToast,
    removeToast,
  };
}
